// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-1dbb0b3c]{height:100vh;padding:0 15px;font-size:14px;line-height:22px;overflow:auto;text-align:left}.page-container .h2[data-v-1dbb0b3c]{margin:10px 0;font-size:16px}[data-v-1dbb0b3c] .van-nav-bar__content{display:block;line-height:46px;background-color:#fff}[data-v-1dbb0b3c] .van-nav-bar .van-icon{color:#000!important;font-size:18px}[data-v-1dbb0b3c] .van-nav-bar__title{color:#000}", ""]);
// Exports
module.exports = exports;
